<template>
  <PageWrapper>
    <grid-item v-if="!loading">
      <transition name="slide-fade" mode="out-in">
        <router-view class="child"></router-view>
      </transition>
    </grid-item>
    <grid-item v-else>
      <Loader color="#759add" />
    </grid-item>
  </PageWrapper>
</template>

<script>
import { mapGetters } from "vuex";

import Loader from "vue-spinner/src/BounceLoader";

export default {
  name: "profile",
  components: { Loader },
  data: function() {
    return {
      loading: true
    };
  },
  computed: {
    ...mapGetters("user", {
      user: "getUser",
      isLoggedIn: "isLoggedIn"
    })
  },
  watch: {
    isLoggedIn: ["setLoader", "redirect"]
  },
  methods: {
    setLoader() {
      this.loading = false;
    },
    redirect() {
      if (!this.isLoggedIn) {
        this.$router.push({ name: this.pages.AUTH_LOGIN });
      }
    }
  },
  created() {
    setTimeout(() => {
      this.redirect();
    }, 1000);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.view-wrapper {
  padding: 3em 0;
  display: flex;
  flex: 1;
  align-items: center;
}

.child {
  min-width: 380px;
}
</style>
